<template>
  <transition name="modal">
    <div v-if="show" class="modal-mask">
      <div class="modal-wrapper" @click="$emit('close')">
        <div class="modal-container" @click.stop="">

<!--          <div class="modal-header">-->
<!--            <slot name="header">-->
<!--              default header-->
<!--            </slot>-->
<!--          </div>-->

          <div class="modal-body">
            <slot name="header">
              default header
            </slot>
            <slot name="content">
              default body
            </slot>
          </div>

<!--          <div class="modal-footer">-->
<!--            <slot name="footer">-->
<!--              default footer-->
<!--              <button class="modal-default-button" @click="$emit('close')">-->
<!--                OK-->
<!--              </button>-->
<!--            </slot>-->
<!--          </div>-->
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    show: Boolean
  }
}
</script>


<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 80%;
  max-width: 1080px;
  margin: 5% auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;

  max-height: 85vh;
  height: auto !important;
  overflow-y: auto;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.vm--modal {
  height: auto !important;
}

</style>



// WEBPACK FOOTER //
// src/components/Modal.vue